import React from "react";
import { EMAIL_BASE_CSS } from '../domain/responsive-css';

export function EmailBaseStyles() {
  return <style>{EMAIL_BASE_CSS}</style>;
}
